export default ({imageURL, imageSize, approved, onClick})=>{
    return                                <div
        style={{ margin:"auto",backgroundColor:"#EEEEEE",height: `${imageSize}px`, borderWidth: "1px", borderColor: "gray", borderStyle: "dashed", ...(approved?{borderWidth:"20px",boxSizing:"border-box", borderStyle:"solid", borderColor:"lightgreen",filter: "brightness(50%)"}:{})}}
        onClick={onClick}
    >
        <img style={{position:"relative",top:"50%",transform: "translateY(-50%)",maxWidth: "100%", maxHeight: "100%"}} src={imageURL}/>
    </div>
}
